import * as types from 'store/modules/dash/mutation-types'
import * as profileimgTypes from 'store/modules/profileimg/mutation-types'
import dash from 'api/dash'
import _ from 'lodash'
import swal from 'sweetalert'

export default {
  state: {
    controlsidebarDisp: false,
    // modules: require('static/module_permis.json'),
    modules: {},
    tinitial: require('static/tinitial.json'),
    tfolder: {
      total: 0,
      rows: [
        {
          main: '',
          temp: '',
          codapp: '',
          folder: ''
        }
      ]
    },
    headerNotiAnnounceTotal: 0,
    headerNotiAnnounceInfiniteLoading: {
      rows: [{
        dteeffec: '',
        numseq: '',
        descapp: '',
        subject: '',
        remark: '',
        codappr: '',
        dteappr: ''
      }]
    },
    headerNotiRequestTotal: 0,
    headerNotiRequestInfiniteLoading: {
      rows: [{
        codapp: '',
        desccodapp: '',
        descapp: '',
        staappr: '',
        detail1: '',
        detail2: '',
        dtereq: ''
      }]
    },
    headerNotiApprove: {
      total: '',
      rows: {}
    },
    keyUp: '',
    currModule: '',
    currCodapp: '',
    mailLang: ''
  },
  getters: {
    [types.GET_CONTROLSIDEBAR_DISP] (state) {
      return state.controlsidebarDisp
    },
    [types.GET_TINITIAL] (state) {
      return state.tinitial
    },
    [types.GET_TFOLDER] (state) {
      return state.tfolder
    },
    [types.GET_MODULES] (state) {
      return state.modules
    },
    [types.GET_HEADER_ANNOUNCE_TOTAL] (state) {
      return state.headerNotiAnnounceTotal
    },
    [types.GET_HEADER_ANNOUNCE_INFINITE_LOADING] (state) {
      return state.headerNotiAnnounceInfiniteLoading
    },
    [types.GET_HEADER_REQUEST_TOTAL] (state) {
      return state.headerNotiRequestTotal
    },
    [types.GET_HEADER_REQUEST_INFINITE_LOADING] (state) {
      return state.headerNotiRequestInfiniteLoading
    },
    [types.GET_HEADER_APPROVE] (state) {
      return state.headerNotiApprove
    },
    [types.GET_CURR_MODULE] (state) {
      return state.currModule
    },
    [types.GET_CURR_CODAPP] (state) {
      return state.currCodapp
    },
    [types.GET_CONTROLSIDEBAR_MAIL_LANG] (state) {
      return state.mailLang
    }
  },
  mutations: {
    [types.SET_CONTROLSIDEBAR_DISP] (state, controlsidebar) {
      state.controlsidebarDisp = !controlsidebar
    },
    [types.SET_CONTROLSIDEBAR_DISP_FALSE] (state, controlsidebar) {
      state.controlsidebarDisp = false
    },
    [types.SET_TINITIAL] (state, tinitial) {
      state.tinitial = tinitial
    },
    [types.SET_TFOLDER] (state, tfolder) {
      state.tfolder = tfolder
    },
    [types.SET_MODULES] (state, modules) {
      state.modules = modules
    },
    [types.SET_HEADER_ANNOUNCE_TOTAL] (state, headerAnnounceTotal) {
      state.headerNotiAnnounceTotal = headerAnnounceTotal
    },
    [types.SET_HEADER_ANNOUNCE_INFINITE_LOADING] (state, headerAnnounceInfiniteLoading) {
      state.headerNotiAnnounceInfiniteLoading = headerAnnounceInfiniteLoading
    },
    [types.SET_HEADER_REQUEST_TOTAL] (state, headerRequestTotal) {
      state.headerNotiRequestTotal = headerRequestTotal
    },
    [types.SET_HEADER_REQUEST_INFINITE_LOADING] (state, headerRequestInfiniteLoading) {
      state.headerNotiRequestInfiniteLoading = headerRequestInfiniteLoading
    },
    [types.SET_HEADER_APPROVE] (state, headerApprove) {
      state.headerNotiApprove = headerApprove
    },
    [types.SET_CURR_PATH] (state, currPath) {
      currPath = typeof currPath.split('?')[0] !== 'undefined' ? currPath.split('?')[0] : currPath
      if (currPath.substr(0, 2) === 'hr') {
        const types = [ 'dashboard', 'request', 'report', 'approve' ]
        _.each(state.modules, function (module, moduleName) {
          if (typeof module.codapp !== 'undefined') {
            _.each(types, function (type) {
              if (typeof module.codapp[type] !== 'undefined') {
                _.each(module.codapp[type], function (codapp, index) {
                  if (module.codapp[type][index] === currPath) {
                    state.currModule = moduleName
                  }
                })
              }
            })
          }
        })
        state.currCodapp = currPath
      } else {
        state.currModule = currPath
        state.currCodapp = ''
      }
    },
    [types.SET_CONTROLSIDEBAR_MAIL_LANG] (state, mailLang) {
      state.mailLang = mailLang.maillang
    }
  },
  actions: {
    [types.RECEIVED_TINITIAL] ({ commit }) {
      dash.receivedTinitial()
        .then((response) => {
          commit(types.SET_TINITIAL, JSON.parse(response.request.response))
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_TFOLDER] ({ commit, dispatch }) {
      dash.receivedTfolder()
        .then((response) => {
          let data = JSON.parse(response.request.response)
          let tfolder = data.rows.filter((folder) => {
            return folder.codapp === 'PROFILEIMG'
          })
          if (tfolder[0]) {
            tfolder = tfolder[0]
          } else {
            tfolder = { folder: '' }
          }
          dispatch(profileimgTypes.RECEIVED_PROFILEIMG_FILEPATH, tfolder)
          commit(types.SET_TFOLDER, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve tfolder again', message)
          dash.receivedTfolder()
            .then((response) => {
              let data2 = JSON.parse(response.request.response)
              let tfolder = data2.rows.filter((folder) => {
                return folder.codapp === 'PROFILEIMG'
              })
              if (tfolder[0]) {
                tfolder = tfolder[0]
              } else {
                tfolder = { folder: '' }
              }
              dispatch(profileimgTypes.RECEIVED_PROFILEIMG_FILEPATH, tfolder)
              commit(types.SET_TFOLDER, data2)
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data2 = error.response.data
                message = data2.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    },
    [types.RECEIVED_MODULES] ({ commit }) {
      dash.receivedModules()
        .then((response) => {
          commit(types.SET_MODULES, JSON.parse(response.request.response))
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve modules again', message)
          dash.receivedModules()
            .then((response) => {
              commit(types.SET_MODULES, JSON.parse(response.request.response))
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    },
    [types.RECEIVED_HEADER_NOTI_TOTAL] ({ commit }, $staappr) {
      dash.receivedHeaderNotiTotal($staappr)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HEADER_ANNOUNCE_TOTAL, data.announce)
          commit(types.SET_HEADER_REQUEST_TOTAL, data.request)
          commit(types.SET_HEADER_APPROVE, data.approve)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve noti again', message)
          dash.receivedHeaderNotiTotal($staappr)
            .then((response) => {
              const data2 = JSON.parse(response.request.response)
              commit(types.SET_HEADER_ANNOUNCE_TOTAL, data2.announce)
              commit(types.SET_HEADER_REQUEST_TOTAL, data2.request)
              commit(types.SET_HEADER_APPROVE, data2.approve)
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data2 = error.response.data
                message = data2.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    },
    [types.RECEIVED_HEADER_ANNOUNCE_INFINITE_LOADING] ({ commit }, params) {
      let triggerInfinite = params.triggerInfinite
      dash.receivedHeaderNotiAnnounceInfiniteLoading(params.searchParams)
        .then((response) => {
          triggerInfinite({ data: JSON.parse(response.request.response), $state: params.$state })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HEADER_REQUEST_INFINITE_LOADING] ({ commit }, params) {
      let triggerInfinite = params.triggerInfinite
      dash.receivedHeaderNotiRequestInfiniteLoading(params.staappr, params.searchParams)
        .then((response) => {
          triggerInfinite({ data: JSON.parse(response.request.response), $state: params.$state })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_CONTROLSIDEBAR_MAIL_LANG] ({ commit }) {
      dash.getMailLang()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_CONTROLSIDEBAR_MAIL_LANG, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_CONTROLSIDEBAR_MAIL_LANG] ({ commit, dispatch }, mailLang) {
      dash.postMailLang(mailLang)
        .then((response) => {
          // const data = JSON.parse(response.request.response)
          dispatch(types.RECEIVED_CONTROLSIDEBAR_MAIL_LANG)
          // console.log(data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dash/index.js